import { Component, ViewEncapsulation, OnInit, HostListener, ElementRef } from '@angular/core';
import { ModalScroll } from './shared/services/api-services/modal-scroll.service';
import { Subscription, Observable } from 'rxjs/';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart } from '@angular/router';
import { SessionTimeoutService } from 'src/app/shared/services/api-services/session-timeout.service';
import { Store } from '@ngrx/store';
import { AppState } from './store/state/app.state';
import { UtilService, QuoteDataCaptureService,  ApplicationDataCaptureService, AuthService } from 'src/app/shared';
import { CURRENT_ENVIROMENT, SERVICE_END_POINT } from './shared/index';
import {Location} from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AlertModal } from 'src/app/model/alert';
import { AnalyticsService } from 'src/app/shared';
import { RefNo } from './model/ngrx';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AppComponent {
  title = 'Digital Customer Journey';
  flag: boolean = false;
  sessionTimeLaps: boolean;
  private subscriptn: Subscription;
  displayFlag = false;
  loginDetails: any[];
  loginDetailsStore: Observable<any[]>;
  private endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];
  unSupportedBrowser=false;
  protected cmsDataunsupportedResolution: any;
  public isLocked:boolean=false;
  protected lockedAlertModalConfig: AlertModal;
  referenceNumberStore: Observable<RefNo[]>;
  referenceNumber: RefNo;
  CMSData;
  constructor(private modalScrollService: ModalScroll, private router: Router,
              private _sessionTimeoutSrv: SessionTimeoutService,
              private store: Store<AppState>, private myUtilService: UtilService,
              private quoteDatacaptureService: QuoteDataCaptureService,
              private applicationDataCaptureService: ApplicationDataCaptureService,
              private location: Location,
              private httpClient: HttpClient,
              private analyticsService: AnalyticsService,
              private utilService: UtilService,
              private activatedRoute: ActivatedRoute,
              private titleService: Title,
              private elementRef:ElementRef, private authService: AuthService) {
    
    this.loginDetailsStore = this.store.select(STORE_VAL.loggedin_detail);
    this.loginDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        this.loginDetails = val[0];
        //console.log(this.loginDetails);
      }
    });

    this.referenceNumberStore = this.store.select(STORE_VAL.ref_no);
    this.referenceNumberStore.subscribe((val: any) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
        }
    });
    /*this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) { 
        //console.log('triggered')
      }
    });*/
  
  }


  async ngOnInit() {
    this.elementRef.nativeElement.removeAttribute("ng-version")
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      const rt = this.getChild(this.activatedRoute);
      rt.data.subscribe(data => {
        //console.log(data);
        this.titleService.setTitle(data.title);
      });
    });
    this.analyticsService.initScript();
    this.disableScroll();
    if(this.loginDetails) {
      this._sessionTimeoutSrv.startTimer();
    }
   
    this._sessionTimeoutSrv.timeoutExpried.subscribe(res => {
      if (this.sessionTimeLaps) {
        // Irrespective of the selection YES/NO after addOnTime laps navigate to login page.
        // Before auto logoff; check if other tab is active
        if (this._sessionTimeoutSrv.getLocalSession() === 'false') {
          this.expireSessionHandler();
        } else {
          this.extendSessionHandler();
        }
      } else {
        if(this.loginDetails && this.router.url !== '/home/logout') {
          this.sessionTimeLaps = true;
          this.displayFlag = true;
          this._sessionTimeoutSrv.addonTime();
        // tslint:disable-next-line: max-line-length
        } else if ((this.router.url !== '/home/logout') && (this.router.url !== '/home/get-your-online-quote') && !((this.router.url.includes('ho-underwriting')))) {
          this.sessionTimeLaps = true;
          this.displayFlag = true;
          this._sessionTimeoutSrv.addonTime();
        }
      }
    });
    if (!this.getBrowserName()) {
      this.router.navigate(['/home/un-support', 'browser']);
      //this.unSupportedBrowser=true;
    }
    this.httpClient.get(this.endPoints.contentDataUrl).subscribe(res=>{
      this.lockedAlertModalConfig=res['modalConfigLocked'];
      this.cmsDataunsupportedResolution=res['unsupportedResolution'];
      this.GetCMSDataService();
    }
   );
    // this.detectScreenSize();
    this.myUtilService.isLocked$.subscribe(res=> {
      if(res){
        this.isLocked=true;
      }else{
        this.isLocked=false;
      }
  });
    this.router.events.subscribe((e) => {
   /*  if (e instanceof NavigationEnd) {
      if (this.referenceNumber === undefined && this.loginDetails === undefined) {
        // tslint:disable-next-line: max-line-length removeing th check for apply journey for the time
        if (!this.router.url.includes('/ho-underwriting') && !this.router.url.includes('/home/after-login') && !this.router.url.includes('/home/get-your-online-quote') && !this.router.url.includes('/home/you-will-need') && !(this.router.url.includes('apply'))) {
          this.router.navigate(['/home/get-your-online-quote']);
        }
      }
    } */
  });  
    await this.authService.redirection();
    // code for browser back button click
    /* this.router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        if (e.navigationTrigger === 'popstate') {
          this.authService.logout();
        }
      }
    }); */
    // code for browser refresh button click
    if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
      const url = window.location.href;
      if (!(url.includes('/home/logout') || url.includes('/home/get-your-online-quote'))) {
        this.authService.logout();
      }
    }
  }


  extendSessionHandler() {
    if (this.loginDetails) {
      //  this.myUtilService.sessionExtend().subscribe(res => {
      this.sessionTimeLaps = false;
      this._sessionTimeoutSrv.resetTimer();
      this.displayFlag = false;
      //  }); 
    } else {
      this.sessionTimeLaps = false;
      this._sessionTimeoutSrv.resetTimer();
      this.displayFlag = false;
    }


  }

  expireSessionHandler() {
    this.sessionTimeLaps = false;
    this._sessionTimeoutSrv.stopTimer();
    this.displayFlag = false;
    if (this.loginDetails) {
      // this.myUtilService.logout().subscribe(res => {
      // });
      if (this.router.url.indexOf('/home/get-your-online-quote')>-1
        || this.router.url.indexOf('/home/you-will-need')>-1
        || this.router.url === '/quote/your-saved-quotes'
        || this.router.url === '/quote/your-product-quote'
        || ((this.router.url.includes('ho-underwriting')))
      ) {
        this.authService.logout();
      } else {
        if(this.router.url.indexOf('/apply')>-1) {
          this.applicationDataCaptureService.onLogoutClick();
        } else {
          this.quoteDatacaptureService.onLogoutClick();
        }
        // added this line for saving the data after logout
        //this.authService.logout();
      }
    } else {
      this.authService.logout();
    }


    //   window.location.href = 'http://lamstwas033.lgnet.co.uk:8080/SAuthGateWeb/login.html?domain=internal&ut=l&entryPoint=http%3A%2F%2Flamstwas023.lgnet.co.uk%3A8080%2Feap%2Frequest%2Fdcj%2FafterAuthentication?quoteRefNo= '
  }

  @HostListener('document: mousemove', ['$event'])
  @HostListener('document: click', ['$event'])
  @HostListener('document: wheel', ['$event'])
  @HostListener('document: keyup', ['$event']) onKeyUpListener() {
    if(this.loginDetails && this.router.url !== '/home/logout' && this.displayFlag !== true) {
      this.sessionTimeLaps = false;
      this._sessionTimeoutSrv.resetTimer();
    // tslint:disable-next-line: max-line-length
    } else if (this.router.url !== '/home/logout' && this.router.url !== '/home/get-your-online-quote' && this.router.url !== '/home/you-will-need' && !((this.router.url.includes('ho-underwriting')))   && this.displayFlag !== true) {
      this.sessionTimeLaps = false;
      this._sessionTimeoutSrv.resetTimer();
    }

  }
  ngOndestroy() {
    this.subscriptn.unsubscribe();
    sessionStorage.setItem('logInClicked', 'N');
  }

  disableScroll() {
    this.subscriptn = this.modalScrollService.scrollFlagState.subscribe(res => {

      if (res.scrollModalFlag === true) {

        (document.querySelector('.test') as HTMLElement).style.position = 'fixed';
        (document.querySelector('.test') as HTMLElement).style.overflow = 'hidden';
      }

      if (res.scrollModalFlag === false) {
        (document.querySelector('.test') as HTMLElement).style.position = 'absolute';
        (document.querySelector('.test') as HTMLElement).style.overflow = 'hidden';

      }
    });
  }
  public getBrowserName() {
    const nav = (window.navigator as any); 
    const isIE = /^.*MSIE [1-10]/i.test(nav.userAgent);
    if (isIE) {
      // alert('you are using older version of IE .........');
      return false;
    }
    const agent = nav.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('opr/') > -1:
      return false;
      case agent.indexOf('yabrowser/') > -1:
      return false;
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome: {
        const fullVersion = navigator.userAgent.substring(navigator.userAgent.indexOf("Chrome") + 7);
        const actualVersion = fullVersion.substr(0, fullVersion.indexOf('.'))
        if (parseInt(actualVersion) < 78) {
          return true;
        } else {
          return true;
        }
      }
      case agent.indexOf('firefox') > -1:
        {
          // tslint:disable-next-line:max-line-length
          const actualVersion = parseInt(agent.substring(agent.lastIndexOf('/') + 1, agent.length)) == NaN ? 0 : parseInt(agent.substring(agent.lastIndexOf('/') + 1, agent.length));
          if (actualVersion < 64) {
            return false;
          } else {
            return true;
          }
        }
      case agent.indexOf('safari') > -1: {
        const fullVersion = navigator.userAgent.substring(navigator.userAgent.indexOf("Version") + 8);
        const actualVersion = fullVersion.substr(0, fullVersion.indexOf('.'))
        if (parseInt(actualVersion) < 11) {
          return false;
        } else {
          return true;
        }

      }
      case agent.indexOf('trident/') > -1:
      return true;
      case agent.indexOf('edge') > -1:
        return true;
      default:
        return false;
    }
  }
  // @HostListener('window:resize', [])
  // public onResize() {
  //   this.detectScreenSize();
  // }
  // private detectScreenSize() {
    //  if (CURRENT_ENVIROMENT.environment === 'higherEnvironment') {
      
    //    if (!window.location.href.includes('ho-underwriting')) {
    //     if (window.innerWidth < 1020 || window.innerHeight < 550) {
    //      // this.router.navigate(['/home/un-support', 'resolution']);
    //       this.unSupportedBrowser = true;
    //     } else {
    //       this.unSupportedBrowser = false;
    //     }

    //    }
      
    // }


  // }
  closeLockedModal() {
    this.isLocked=false;
  }
  GetCMSDataService() {
    //console.log('original value = ', );
    const URL =  SERVICE_END_POINT.higherEnvironment.CMS_Unsupported;
    this.utilService.getCMSData(URL)
    .subscribe(res => {
      //console.log('2 GetCMSDataService => ',  this.cmsDataunsupportedResolution.Detail);
      this.CMSData = res;
      if(this.CMSData) {
      /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.cmsDataunsupportedResolution.header = this.CMSData.string_ResolutionNotSupportedTitle;
        this.cmsDataunsupportedResolution.Detail = this.CMSData.string_ResolutionNotSupportedText;
        //console.log('changed value = ',  this.cmsDataunsupportedResolution.Detail);
      }
    });
  }
  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
}
